import styled from 'styled-components';
export const ImageWrapper = styled.div<{
  borderRadius?: number;
  wrapperWidth?: string;
}>`
  position: relative;
  overflow: hidden;

  & img {
    margin: 0;
    object-fit: ${(p) => (p.wrapperWidth ? 'fill' : 'cover')};
    width: ${(p) => (p.wrapperWidth ? p.wrapperWidth : '100%')};
    border-radius: 8px;
  }
`;
